export const FIELD_LABELS = {
  sku: "SKU / model no.", product_name: "Product name", door_type: "Door type", width_in: "Width", height_in: "Height",
  size: "Size (W x H)", cost: "Cost", ext_int: "Exterior / interior", material: "Material / finish", notes: "Notes",
};

export const sizeText = (c) => {
  if (c.width_in && c.height_in) return `${c.width_in}" x ${c.height_in}"`;
  if (c.width_min || c.width_max || c.height_max) {
    const w = c.width_min && c.width_max ? `${c.width_min}–${c.width_max}"` : c.width_min ? `${c.width_min}"+` : `≤${c.width_max}"`;
    return `${w} W x ≤${c.height_max ?? "any"}" H`;
  }
  return "Any size";
};

export const inputCls = "h-8 w-full rounded-md border border-slate-800 bg-slate-900/70 px-2 text-sm text-slate-100 outline-none transition-colors focus:border-amber-500/70";
export const pillBtn = "inline-flex h-9 items-center gap-1.5 rounded-full border border-slate-700 px-4 text-sm font-medium text-slate-200 transition-colors hover:border-amber-500/60 hover:text-amber-200 disabled:opacity-50";
export const primaryBtn = "inline-flex h-9 items-center gap-2 rounded-full bg-amber-500 px-5 text-sm font-semibold text-slate-950 transition-colors hover:bg-amber-400 disabled:opacity-60";
